import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { AppBlockedComponent } from "../components/Layout/Splash/AppBlockedComponent/AppBlockedComponent";
import { globalTranslationFiles } from "../utils/help/localization/localization";
import { getRestaurantStaticProps } from "../utils/help/staticProps/restaurantStaticProps";

function CookieCheckPage() {
  return (
    <div data-testid="cookie-check-component">
      <AppBlockedComponent />
    </div>
  );
}

export async function getStaticProps({ locale }: { locale: any }) {
  // Every page needs the restaurant config in redux: _app hydrates from
  // pageProps.restaurantInfo, and the shared layout reads it. Before #4204
  // useRestaurantData fetched it in the browser on EVERY page, so a page
  // that never fetched it still had it. #4204
  const { restaurantInfo, socialMediaInfo } = await getRestaurantStaticProps();

  return {
    props: {
      restaurantInfo,
      socialMediaInfo,
      ...(await serverSideTranslations(locale, [
        ...globalTranslationFiles,
        "common",
      ])),
      // Will be passed to the page component as props
    },
  };
}

CookieCheckPage.displayName = "CookieCheckPage";

export default CookieCheckPage;
